import { getApolloClient } from 'owa-apollo';
import { ApplyConversationActionContext } from 'owa-mail-triage-action-utils';
import {
    CategorizeConversationDocument,
    CategorizeConversationMutation,
} from './graphql/__generated__/categorizeConversationMutation.interface';
import getEwsRequestDateString from 'owa-mail-triage-action-utils/lib/getEwsRequestDateString';
import { isFeatureEnabled } from 'owa-feature-flags';

type CategorizeConversationResult = CategorizeConversationMutation['categorizeConversation'];

/**
 * Issue the service request to update categories of specified conversations
 * @param conversationActionContexts the conversation context to be categorized
 * @param contextFolderId the context folder id that the conversation belongs to
 * @param categoriesToAdd the categories to be added to the conversations
 * @param categoriesToRemove the categories to be removed from the conversations
 * @param clearCategories whether to clear categories
 * @param mailboxInfo routing information for the mailbox
 * @return a promise which contains ApplyConversationActionResponseMessage
 */
export default async function updateConversationsCategoriesService(
    conversationActionContexts: ApplyConversationActionContext[],
    contextFolderId: string,
    categoriesToAdd: string[],
    categoriesToRemove: string[],
    clearCategories: boolean
): Promise<CategorizeConversationResult> {
    const conversationSnapShots = conversationActionContexts.map(context => {
        return {
            id: context.conversationId,
            messagesAsOf: getEwsRequestDateString(context.conversationLastSyncTimeStamp),
        };
    });
    const client = await getApolloClient();
    const result = await client.mutate({
        variables: {
            conversations: conversationSnapShots,
            categoriesToAdd: categoriesToAdd,
            categoriesToRemove: categoriesToRemove,
            clearAllCategories: clearCategories,
            processRightAway: isFeatureEnabled('tri-processConversationCategoriesRightAway'),
            folderId: contextFolderId,
        },
        mutation: CategorizeConversationDocument,
    });

    return result?.data?.categorizeConversation;
}
